import React from "react";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import "./contribution-breakdown-modal.scss";
import { addCommas } from "../../helpers/helpers";

const ContributionBreakdownModal = (props) => {
  const { selectedMemberShip } = props;
  const { date, transactionType, membership, amount } = selectedMemberShip;
  const { contributionBreakdown } = amount;
  const screenWidth = screen.width;
  const newDate = new Date(date);
  const day = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const year = newDate.getFullYear();
  return (
    <div className="contribution-breakdown-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="breakdown-modal-body ps-3">
        <p className="heading">Contribution breakdown</p>
      </div>

      <Row className="mt-4 ps-3 pe-4 membership-wrapper">
        <Col lg={2} sm={6} xs={6}>
          <p className="membership-title">Date</p>
          <p className="membership-data">{`${day > 9 ? day : `0${day}`}/${
            month > 9 ? month : `0${month}`
          }/${year}`}</p>
        </Col>
        <Col lg={4} sm={6} xs={6}>
          <p className="membership-title">Transaction</p>
          <p className="membership-data">{transactionType}</p>
        </Col>
        <Col lg={3} sm={6} xs={6}>
          <p className="membership-title">Membership No.</p>
          <p className="membership-data">{`${membership.potId} ${membership.potName}`}</p>
        </Col>
        {screenWidth > 430 ? (
          <Col lg={3} sm={6} xs={6} className="text-end">
            <p className="membership-title">Amount</p>
            <p className="membership-data">
              {amount.totalAmount.includes("-")
                ? `- £${parseFloat(
                    addCommas(
                      amount.totalAmount.split("-")[1], // eslint-disable-line
                    ),
                  ).toFixed(2)}`
                : `+ £${parseFloat(
                    addCommas(
                      amount.totalAmount, // eslint-disable-line
                    ),
                  ).toFixed(2)}`}
            </p>
          </Col>
        ) : (
          <>
            <Col lg={3} sm={6} xs={6} className="text-start">
              <p className="membership-title">Amount</p>
              <p className="membership-data">
                {amount.totalAmount.includes("-")
                  ? `- £${parseFloat(
                      addCommas(
                        amount.totalAmount.split("-")[1], // eslint-disable-line
                      ),
                    ).toFixed(2)}`
                  : `+ £${parseFloat(
                      addCommas(
                        amount.totalAmount, // eslint-disable-line
                      ),
                    ).toFixed(2)}`}
              </p>
            </Col>
            <hr className="mt-0" />
          </>
        )}
      </Row>
      {screenWidth > 430 ? (
        <Row className="mt-4 ps-3 pe-4">
          <Col lg={4} md={4} sm={4} xs={6}>
            <p className="membership-title">Fund</p>
          </Col>
          <Col lg={2} md={2} sm={2} xs={6} className="text-end">
            <p className="membership-title">Fund %</p>
          </Col>
          <Col lg={2} md={2} sm={2} xs={4} className="text-end">
            <p className="membership-title">Units bought</p>
          </Col>
          <Col lg={2} md={2} sm={2} xs={4} className="text-end">
            <p className="membership-title">Unit price</p>
          </Col>
          <Col lg={2} md={2} sm={2} xs={4} className="text-end">
            <p className="membership-title">Amount</p>
          </Col>
          {contributionBreakdown?.map((item) => {
            return (
              <>
                <Col lg={4} xs={6}>
                  <p className="membership-data">{item.fundName}</p>
                </Col>
                <Col lg={2} xs={6} className="text-end">
                  <p className="membership-data"> {`${item.percentage}%`}</p>
                </Col>
                <Col lg={2} xs={4} className="text-end">
                  <p className="membership-data">{item.units}</p>
                </Col>
                <Col lg={2} xs={4} className="text-end">
                  <p className="membership-data">{`£${item.unitPrice}`}</p>
                </Col>
                <Col lg={2} xs={4} className="text-end">
                  <p className="membership-data">{`£${item.unitTotalValue}.00`}</p>
                </Col>
              </>
            );
          })}
        </Row>
      ) : (
        <Row className="mt-2 ps-0 pe-0">
          {contributionBreakdown?.map((item) => {
            return (
              <>
                <Col lg={4} xs={8}>
                  <p className="membership-title">Fund</p>
                  <p className="membership-data">{item.fundName}</p>
                </Col>
                <Col lg={2} xs={4} className="text-start">
                  <p className="membership-title">Fund %</p>
                  <p className="membership-data"> {`${item.percentage}%`}</p>
                </Col>
                <Col lg={2} xs={4} className="text-start">
                  <p className="membership-title">Units bought</p>
                  <p className="membership-data">{item.units}</p>
                </Col>
                <Col lg={2} xs={4} className="text-start">
                  <p className="membership-title">Unit price</p>
                  <p className="membership-data">{`£${item.unitPrice}`}</p>
                </Col>
                <Col lg={2} xs={4} className="text-start">
                  <p className="membership-title">Amount</p>
                  <p className="membership-data">{`£${item.unitTotalValue}.00`}</p>
                </Col>
                <hr className="mt-0" />
              </>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default ContributionBreakdownModal;
